if (!customElements.get('secret-cart-page')) {
  customElements.define('secret-cart-page', class extends HTMLElement {
    connectedCallback() {
      this.pending = new Map();
      this.invalidInputs = new Set();
      this.addEventListener('input', (event) => {
        const input = event.target.closest('[data-cart-page-quantity]');
        if (!input) return;
        this.queueQuantity(input);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.flushPending(), 400);
      });
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-cart-page-quantity]');
        if (!input) return;
        this.queueQuantity(input);
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.flushPending(), 400);
      });
      this.addEventListener('click', async (event) => {
        const step = event.target.closest('[data-cart-page-step]');
        if (step) {
          event.preventDefault();
          if (this.getAttribute('aria-busy') === 'true') return;
          const input = step.closest('[data-cart-page-item]').querySelector('[data-cart-page-quantity]');
          const value = input.value.trim();
          const quantity = Number(value);
          if (!value || !Number.isSafeInteger(quantity) || quantity < 0) {
            this.queueQuantity(input);
            return;
          }
          input.value = String(Math.max(0, quantity + Number(step.dataset.cartPageStep)));
          this.queueQuantity(input);
          this.flushPending();
          return;
        }
        const remove = event.target.closest('[data-cart-page-remove]');
        const toggle = event.target.closest('[data-cart-page-subscription]');
        if (!remove && !toggle) return;
        event.preventDefault();
        if (this.getAttribute('aria-busy') === 'true') return;
        const key = (remove || toggle).closest('[data-cart-page-item]').dataset.key;
        if (!await this.flushPending()) return;
        const item = Array.from(this.querySelectorAll('[data-cart-page-item]')).find((row) => row.dataset.key === key);
        if (!item) return;
        if (remove) this.update({ id: key, quantity: 0 });
        else {
          const currentToggle = item.querySelector('[data-cart-page-subscription]');
          this.update({
            id: key,
            quantity: Number(item.dataset.quantity),
            selling_plan: currentToggle.getAttribute('aria-pressed') === 'true' ? null : Number(currentToggle.dataset.planId)
          });
        }
      });
      this.addEventListener('submit', async (event) => {
        if (!window.SecretCandyCart) return;
        event.preventDefault();
        if (this.getAttribute('aria-busy') === 'true') return;
        if (await this.flushPending()) window.SecretCandyCart.checkout();
      });
    }
    showError(message) {
      const error = this.querySelector('[data-cart-page-error]');
      error.textContent = message;
      error.hidden = false;
    }
    queueQuantity(input) {
      const item = input.closest('[data-cart-page-item]');
      const value = input.value.trim();
      const quantity = Number(value);
      if (!value || !Number.isSafeInteger(quantity) || quantity < 0) {
        this.pending.delete(item.dataset.key);
        this.invalidInputs.add(item.dataset.key);
        input.setAttribute('aria-invalid', 'true');
        this.showError(this.dataset.invalidQuantityMessage);
        return;
      }
      input.removeAttribute('aria-invalid');
      this.invalidInputs.delete(item.dataset.key);
      this.querySelector('[data-cart-page-error]').hidden = true;
      if (quantity !== Number(item.dataset.quantity)) this.pending.set(item.dataset.key, quantity);
      else this.pending.delete(item.dataset.key);
    }
    async flushPending() {
      clearTimeout(this.timer);
      if (this.invalidInputs.size) {
        this.showError(this.dataset.invalidQuantityMessage);
        return false;
      }
      if (this.flushing) return this.flushing;
      if (!this.pending.size) return true;
      const updates = Object.fromEntries(this.pending);
      this.pending.clear();
      this.flushing = this.update({ updates }, true);
      const succeeded = await this.flushing;
      this.flushing = null;
      return succeeded;
    }
    async update(body, quantities = false) {
      this.querySelector('[data-cart-page-error]').hidden = true;
      try {
        if (!window.SecretCandyCart) throw new Error(this.dataset.errorMessage);
        const data = await (quantities ? window.SecretCandyCart.quantities(body) : window.SecretCandyCart.change(body));
        if (!data) throw new Error(this.dataset.errorMessage);
        return true;
      } catch (failure) {
        const currentError = this.querySelector('[data-cart-page-error]');
        this.showError(currentError.textContent || failure.message || this.dataset.errorMessage);
        return false;
      }
    }
  });
}
